import { render, staticRenderFns } from "./PrePagamento.vue?vue&type=template&id=21248eac&"
import script from "./PrePagamento.vue?vue&type=script&lang=js&"
export * from "./PrePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports